export default __webpack_public_path__ + "static/upload-f28927ba7f3fde82af4895d1be287bea.png";